import { PopoverPlacement } from "@idui/react-popover";
import { AddLocationAlt } from "@mui/icons-material";
import { startCase } from "lodash";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { MuiButton } from "../../../../controls";
import { FramerTooltip } from "../../../tooltips";

interface IButtonAddStationToFixedRide {
  watchedId: number | undefined;
  onClick: () => void;
}

export const ButtonAddStationToFixedRide: FC<IButtonAddStationToFixedRide> = ({
  watchedId,
  onClick,
}) => {
  const { t } = useTranslation();
  return (
    <FramerTooltip
      content={
        !watchedId
          ? t("ride.PLEASE_CHOOSE_STATION_FIRST")
          : startCase(t("general.ADD_ENTITY", { entity: t("station.single") }))
      }
      placement={PopoverPlacement.top}
    >
      {/* Prevent "A disabled element does not fire events." MUI error*/}
      <span>
        <MuiButton disabled={!watchedId} onClick={onClick} color="primary">
          {t(`general.ADD_ENTITY`, { entity: t(`station.single`) })}
          <AddLocationAlt />
        </MuiButton>
      </span>
    </FramerTooltip>
  );
};
